import { System } from './constants';

export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}

export const maskEmail = (email: any) => {
  const [localPart, domain] = email.split('@');

  if (localPart.length <= 3) {
    return localPart[0] + '*'.repeat(localPart.length - 1) + '@' + domain;
  }

  const firstChar = localPart[0];
  const lastTwo = localPart.slice(-2);
  const maskedMiddle = '*'.repeat(localPart.length - 3);

  return `${firstChar}${maskedMiddle}${lastTwo}@${domain}`;
};

export function compareIgnoreCase(str1: string, str2: string): boolean {
  return str1?.toLowerCase() === str2?.toLowerCase();
}

export function convertToLocalDateTime(isoString: string) {
  const date = new Date(isoString + 'Z');
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const getUserStatus = (status: System.UserStatusClientEventType) => {
  switch (status) {
    case System.UserStatusClientEvent.Online:
      return {
        label: 'Online',
        class: 'online',
        color: '#43b581',
        icon: 'ellipse-outline',
      };

    case System.UserStatusClientEvent.Offline:
      return {
        label: 'Offline',
        class: 'offline',
        color: '#747f8d',
        icon: 'ellipse-outline',
      };

    case System.UserStatusClientEvent.Busy:
      return {
        label: 'Busy',
        class: 'busy',
        color: '#f04747',
        icon: 'remove-circle',
      };

    case System.UserStatusClientEvent.OnBreak:
      return {
        label: 'On Break',
        class: 'break',
        color: '#faa61a',
        icon: 'pause',
      };

    case System.UserStatusClientEvent.Idle:
      return {
        label: 'Idle',
        class: 'idle',
        color: '#faa61a',
        icon: 'pause',
      };

    case System.UserStatusClientEvent.OnDuty:
      return {
        label: 'On Duty',
        class: 'duty',
        color: '#3b82f6',
        icon: 'checkmark-circle',
      };

    case System.UserStatusClientEvent.InEmergency:
      return {
        label: 'Emergency',
        class: 'emergency',
        color: '#e11d48',
        icon: 'warning',
      };
    case System.UserStatusClientEvent.Available:
      return {
        label: 'Available',
        class: 'available',
        color: '#43b581',
        icon: 'warning',
      };
    case System.UserStatusClientEvent.Busy:
      return {
        label: 'Emergency',
        class: 'emergency',
        color: '#faa61a',
        icon: 'warning',
      };
    case System.UserStatusClientEvent.DoNotDisturb:
      return {
        label: 'Do Not Disturb',
        class: 'donotdisturb',
        color: '#e11d48',
        icon: 'warning',
      };

    default:
      return {
        label: 'Unknown',
        class: 'unknown',
        color: '#cccccc',
        icon: 'help-circle',
      };
  }
};
